module.exports = __webpack_public_path__ + "img/ph.c5c952db.svg";